export enum ClientSegments {
    PI = 'PI',
    WM = 'WM',
    UNKNOWN = 'UNKNOWN',
}